module.exports = __webpack_public_path__ + "img/alternate-tiktok-icon.ee142371.svg";